export default __webpack_public_path__ + "static/media/new-logo-w.c59488f1.svg";